/**
 *  ScanlinesFilter
 *
 *  Created by Legman on 09/11/2016.
 *
 */

import glsl     from "glslify";

/**
 * @class
 */
export default class ScanlinesFilter extends PIXI.Filter {
    /**
     * @param {PIXI.Sprite} [sprite]
     * @constructor
     */
    constructor(sprite) {
        const maskMatrix = new PIXI.Matrix();

        super(null, glsl("./scanlines.glsl"));

        this.maskSprite = sprite;
        this.maskMatrix = maskMatrix;

        this.uniforms.time = 0;
        this.uniforms.filterMatrix = maskMatrix;
    }

    apply(filterManager, input, output) {
        this.uniforms.filterMatrix = filterManager.calculateSpriteMatrix(this.maskMatrix, this.maskSprite);
        filterManager.applyFilter(this, input, output);
    }

    /**
     * @returns {number}
     */
    get time() {
        return this.uniforms.time;
    }

    /**
     * @param {number} value
     */
    set time(value) {
        this.uniforms.time = value;
    }
}
